// extracted by mini-css-extract-plugin
export default {"taggedList":"TaggedList_taggedList__xk5RE"};